import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { RequestComunicadosModelProps } from 'pages/comunicado/types';

export function useQueryComunicado({ id }: { id?: number }) {
    const requestListagem = useRequestListagem();

    return useQuery<RequestComunicadosModelProps>(
        ['queryComunicado', id],
        () =>
            requestListagem({
                url: `/gestao/comunicado/${id}`,
            }).then((res) => res?.data?.data),
        {
            enabled: false,
        },
    );
}
